import { NavLink, useNavigate } from "react-router-dom";
import {
  Drawer,
  Box,
  IconButton,
  Button,
  Menu,
  MenuItem,
  Collapse,
  List,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import MenuIcon from "@mui/icons-material/Menu";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import "./Navigation.css";

import PropTypes from "prop-types";
import PopupDialog from "../common/PopupDialog";
import ContactForm from "../contactForm/ContactForm";

export default function Navigation({ mobileMenu }) {
  Navigation.propTypes = {
    mobileMenu: PropTypes.bool,
  };
  const [open, setOpen] = useState(false);
  const [openQuote, setOpenQuote] = useState(false);
  const navigate = useNavigate();

  // Desktop Dropdown State
  const [servicesAnchor, setServicesAnchor] = useState(null);
  // const [packagesAnchor, setPackagesAnchor] = useState(null);

  // Mobile Collapse State
  const [servicesOpen, setServicesOpen] = useState(false);
  // const [packagesOpen, setPackagesOpen] = useState(false);

  const handleServicesClick = (event) => {
    if (mobileMenu) {
      setServicesOpen(!servicesOpen);
    } else {
      setServicesAnchor(event.currentTarget);
    }
  };

  // const handlePackagesClick = (event) => {
  //   if (mobileMenu) {
  //     setPackagesOpen(!packagesOpen);
  //   } else {
  //     setPackagesAnchor(event.currentTarget);
  //   }
  // };

  const handleClose = () => {
    setServicesAnchor(null);
    // setPackagesAnchor(null);
  };

  const handleMenuClick = (path) => {
    navigate(path);
    handleClose();
    if (mobileMenu) setOpen(false);
  };

  if (mobileMenu) {
    return (
      <>
        {/* Hamburger Icon */}
        <MenuIcon onClick={() => setOpen(true)} style={{ fontSize: 30 }} />

        <Drawer anchor="left" open={open} onClose={() => setOpen(false)}>
          <Box
            sx={{
              width: 260,
              p: 3,
              display: "flex",
              flexDirection: "column",
              gap: 2,
            }}
          >
            {/* Close Button */}
            <IconButton
              onClick={() => setOpen(false)}
              sx={{ alignSelf: "flex-end" }}
            >
              <CloseIcon />
            </IconButton>

            {/* Nav Links */}
            <NavLink
              to="/"
              onClick={() => setOpen(false)}
              className="mobile-nav-link"
            >
              Home
            </NavLink>

            {/* Services Mobile Dropdown */}
            <Box>
              <Box
                className="mobile-nav-link"
                onClick={handleServicesClick}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  cursor: "pointer",
                }}
              >
                Services
                {servicesOpen ? (
                  <KeyboardArrowUpIcon />
                ) : (
                  <KeyboardArrowDownIcon />
                )}
              </Box>
              <Collapse in={servicesOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {/* <ListItemButton sx={{ pl: 4 }} onClick={() => handleMenuClick('/services')}>
                    <ListItemText primary="All Services" />
                  </ListItemButton> */}
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => handleMenuClick("/services/planning")}
                  >
                    <ListItemText primary="House Planning and Design" />
                  </ListItemButton>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => handleMenuClick("/services/approval")}
                  >
                    <ListItemText primary="Plan Approval" />
                  </ListItemButton>
                  {/* <ListItemButton sx={{ pl: 4 }} onClick={() => handleMenuClick('/services/construction')}>
                    <ListItemText primary="Construction" />
                  </ListItemButton> */}
                  <ListItemButton
                    sx={{ pl: 4 }}
                    onClick={() => handleMenuClick("/services/interior")}
                  >
                    <ListItemText primary="Interior" />
                  </ListItemButton>
                </List>
              </Collapse>
            </Box>

            {/* Packages Mobile Dropdown */}
            <NavLink
              to="/packages"
              onClick={() => setOpen(false)}
              className="mobile-nav-link"
            >
              Packages
            </NavLink>
            {/* <Box>
              <Box 
                className="mobile-nav-link" 
                onClick={handlePackagesClick}
                sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer' }}
              >
                Packages
                {packagesOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
              </Box>
              <Collapse in={packagesOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  <ListItemButton sx={{ pl: 4 }} onClick={() => handleMenuClick('/packages')}>
                    <ListItemText primary="All Packages" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} onClick={() => handleMenuClick('/packages/design')}>
                    <ListItemText primary="Design Packages" />
                  </ListItemButton>
                  <ListItemButton sx={{ pl: 4 }} onClick={() => handleMenuClick('/packages/construction')}>
                    <ListItemText primary="Construction Packages" />
                  </ListItemButton>
                </List>
              </Collapse>
            </Box> */}

            {/* <NavLink
              to="/projects"
              onClick={() => setOpen(false)}
              className="mobile-nav-link"
            >
              Projects
            </NavLink> */}
            <NavLink
              to="/contact"
              onClick={() => setOpen(false)}
              className="mobile-nav-link"
            >
              Contact Us
            </NavLink>
            {/* <NavLink
              to="/aboutUs"
              onClick={() => setOpen(false)}
              className="mobile-nav-link"
            >
              About Us
            </NavLink> */}

            {/* Button right after the list */}
            <Button
              fullWidth
              variant="contained"
              sx={{
                bgcolor: "#000",
                color: "#fff",
                py: 1.2,
                mt: 2 /* space above */,
                borderRadius: "10px",
                fontWeight: 600,
                "&:hover": { bgcolor: "#333" },
              }}
              onClick={() => {
                setOpen(false);
                setOpenQuote(true);
              }}
            >
              REQUEST QUOTE
            </Button>

            {/* Extra small space at bottom (optional) */}
            <Box sx={{ height: "10px" }}></Box>
          </Box>
        </Drawer>
        <PopupDialog
          open={openQuote}
          title="Request a Quote"
          onClose={() => setOpenQuote(false)}
          maxWidth="md"
        >
          <ContactForm
            title="Tell us about your project"
            subtitle="We’ll get back to you shortly with details"
            buttonText="Submit"
            onSubmit={() => setOpenQuote(false)}
          />
        </PopupDialog>
      </>
    );
  }

  return (
    <ul className="nav-list">
      <li>
        <NavLink
          to="/"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Home
        </NavLink>
      </li>
      {/* <li>
        <NavLink
          to="/aboutUs"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          About Us
        </NavLink>
      </li> */}

      {/* Services Dropdown */}
      <li
        onMouseEnter={(e) => setServicesAnchor(e.currentTarget)}
        onMouseLeave={() => setServicesAnchor(null)}
        className="dropdown-item"
      >
        <span className="nav-link-span">
          Services{" "}
          <KeyboardArrowDownIcon
            sx={{ fontSize: 16, verticalAlign: "middle" }}
          />
        </span>
        <Menu
          anchorEl={servicesAnchor}
          open={Boolean(servicesAnchor)}
          onClose={() => setServicesAnchor(null)}
          slotProps={{ list: { onMouseLeave: () => setServicesAnchor(null) } }}
          sx={{ pointerEvents: "none" }}
          PaperProps={{ sx: { pointerEvents: "auto" } }}
        >
          {/* <MenuItem onClick={() => handleMenuClick('/services')}>All Services</MenuItem> */}
          <MenuItem onClick={() => handleMenuClick("/services/planning")}>
            House Planning and Design
          </MenuItem>
          <MenuItem onClick={() => handleMenuClick("/services/approval")}>
            Plan Approval
          </MenuItem>
          {/* <MenuItem onClick={() => handleMenuClick('/services/construction')}>Construction</MenuItem> */}
          <MenuItem onClick={() => handleMenuClick("/services/interior")}>
            Interior
          </MenuItem>
        </Menu>
      </li>

      {/* Packages Dropdown */}
      <li>
        <NavLink
          to="/packages"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Packages
        </NavLink>
      </li>
      {/* <li 
          onMouseEnter={(e) => setPackagesAnchor(e.currentTarget)}
          onMouseLeave={() => setPackagesAnchor(null)}
          className="dropdown-item"
        >
          <span 
            className="nav-link-span"
          >
            Packages <KeyboardArrowDownIcon sx={{ fontSize: 16, verticalAlign: 'middle' }}/>
          </span>
          <Menu
            anchorEl={packagesAnchor}
            open={Boolean(packagesAnchor)}
            onClose={() => setPackagesAnchor(null)}
            slotProps={{ list: { onMouseLeave: () => setPackagesAnchor(null) } }}
            sx={{ pointerEvents: 'none' }}
            PaperProps={{ sx: { pointerEvents: 'auto' } }}
          >
            <MenuItem onClick={() => handleMenuClick('/packages')}>All Packages</MenuItem>
            <MenuItem onClick={() => handleMenuClick('/packages/design')}>Design Packages</MenuItem>
            <MenuItem onClick={() => handleMenuClick('/packages/construction')}>Construction Packages</MenuItem>
          </Menu>
        </li> */}

      {/* <li>
        <NavLink
          to="/projects"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Projects
        </NavLink>
      </li> */}

      <li>
        <NavLink
          to="/contact"
          className={({ isActive }) => (isActive ? "active" : "")}
        >
          Contact Us
        </NavLink>
      </li>
    </ul>
  );
}
